import { render } from "./FocusModeNavigationControl.vue?vue&type=template&id=a2791b58&scoped=true&ts=true"
import script from "./FocusModeNavigationControl.vue?vue&type=script&lang=ts"
export * from "./FocusModeNavigationControl.vue?vue&type=script&lang=ts"

import "./FocusModeNavigationControl.vue?vue&type=style&index=0&id=a2791b58&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2791b58"]])

export default __exports__